import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../components/vendorWebFolder/helperFunctions/axiosInstance";

export const fetchVendorDashboard = createAsyncThunk(
  "vendorDashboard/fetchAll",
  async (_, thunkAPI) => {
    try {
      // ✅ Get the entire redux state
      const state = thunkAPI.getState();

      // ✅ Access vendorId from vendorAuth slice
      const vendorId = state.vendorAuth?.vendorId;


      // ✅ Make API call, pass vendorId as param or in URL as needed
      const response = await axiosInstance.get(
        `/vendorClusterBatches/vendorClusterBatches/${vendorId}`
      );


      return response.data;
    } catch (error) {
      // ✅ Prepare error message
      const message = error.response?.data?.message || "Something went wrong";

      // ✅ Return custom error to rejected case
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const vendorDashboardSlice = createSlice({
  name: "vendorDashboard",
  initialState: {
    vendorDashboardData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorDashboardData = action.payload;
      })
      .addCase(fetchVendorDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch vendor dashboard data";
      });
  },
});

export default vendorDashboardSlice.reducer;
